module.exports = __webpack_public_path__ + "img/mp.552120fa.png";